export default function replaceURLs(text) {
    if (!text) return text;
    // Regular expression to match "https://files-dev-myxp.gevme.com";

    // Dev mode
    const devRegex = /(https:\/\/files-dev-myxp\.gevme\.com)/g;
    const devReplacement = 'https://files-dev-myxp-mobile.gevme.com';

    // Dev mode
    const stagingRegex = /(https:\/\/files-myxp\.gev\.me)/g;
    const stagingReplacement = 'https://files-myxp-mobile.gev.me';

    // Production mode
    const prodRegex = /(https:\/\/files-myxp\.gevme\.com)/g;
    const prodReplacement = 'https://files-myxp-mobile.gevme.com';

    return text
        .replace(devRegex, devReplacement)
        .replace(stagingRegex, stagingReplacement)
        .replace(prodRegex, prodReplacement);
}
